const o="2.33.0";export{o as version};
